import { NftVoterClient } from '@utils/uiTypes/NftVoterClient'
import { ChatMessageBody } from '@realms-today/spl-governance'
import { Connection, LAMPORTS_PER_SOL, PublicKey } from '@solana/web3.js'
import { notify } from '@utils/notifications'
import { VotingClient } from '@utils/uiTypes/VotePlugin'
import {
  getNftVoteRecordProgramAddress,
  getUsedNftsForProposal,
} from 'NftVotePlugin/accounts'
import { getVotingNfts } from '@hooks/queries/plugins/nftVoter'

//lamports costs hardcoded for now.
//TODO figure out better cost handling
const castVoteIxAndUpdateVoterWeightIxCost = 1515320
const oneAvgNftCost = 1670400
const commentCostIx = 1673440
const commentAvgCharacterCost = 6960
const singleTransactionCosts = 5000

export const calcCostOfNftVote = async (
  connection: Connection,
  comment: ChatMessageBody | undefined,
  numberOfTransactions: number,
  proposalPk: PublicKey,
  votingPlugin: VotingClient,
  realmPk: PublicKey,
  userPk: PublicKey
) => {
  let nftToVoteCount = 0
  const votingNfts = await getVotingNfts(connection, realmPk, userPk)

  const nftsAlreadyUsedToVote = await getUsedNftsForProposal(
    votingPlugin.client as NftVoterClient,
    proposalPk
  )
  if (nftsAlreadyUsedToVote.length > 0) {
    for (const nft of votingNfts) {
      const { nftVoteRecord } = await getNftVoteRecordProgramAddress(
        proposalPk,
        nft.id,
        votingPlugin.client!.program.programId!
      )
      if (
        !nftsAlreadyUsedToVote.find(
          (x) => x.publicKey.toBase58() === nftVoteRecord.toBase58()
        )
      ) {
        nftToVoteCount++
      }
    }
  } else {
    nftToVoteCount = votingNfts.length
  }

  let baseCost = castVoteIxAndUpdateVoterWeightIxCost
  const nftVotesCosts = oneAvgNftCost * nftToVoteCount
  if (comment) {
    baseCost += commentCostIx + comment.value.length * commentAvgCharacterCost
  }
  const pureTransactionsCosts = numberOfTransactions * singleTransactionCosts
  const totalVoteCost = nftVotesCosts + baseCost + pureTransactionsCosts
  return totalVoteCost
}

export const checkHasEnoughSolToVote = async (
  totalVoteCost: number,
  walletPk: PublicKey,
  connection: Connection
) => {
  const currentWalletSol = await connection.getBalance(walletPk)
  const hasEnoughSol = currentWalletSol - totalVoteCost > 0

  if (!hasEnoughSol) {
    notify({
      type: 'error',
      message: `Your wallet don't have enough SOL to vote. You need at least ${
        totalVoteCost / LAMPORTS_PER_SOL
      } SOL to vote`,
    })
  }
  return hasEnoughSol
}
